import React, { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useFetch, CardHeader, PseudoStates, Table } from '@cordata/buffet';
import { camelCase } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  formatDate,
  useQueryParam,
} from '~/utils';

const Cell = ({ data, header }) => {
  let formattedData = data.value;

  if (header.dataType === 'date') {
    formattedData = formatDate(data.value);
  }

  return (
    <>{formattedData}</>
  );
};

Cell.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
  header: PropTypes.shape({
    dataType: PropTypes.string,
  }).isRequired,
};

const QueueCard = ({
  id, title, className, onItemClick,
}) => {
  const [status, data] = useFetch(`queues/${id}`);

  const [sort, setSort] = useQueryParam(`sort-${id}`, [], {
    serialize: (newSorted) => newSorted.map(s => `${s.desc ? '-' : ''}${s.id}`).join(','),
    deserialize: (string) => string.split(',').map(s => ({ desc: s.startsWith('-'), id: s.replace('-', '') })),
  });

  useEffect(() => {
    const localStorageSort = localStorage.getItem(`sort-${id}`);

    if (localStorageSort !== null) {
      setSort(JSON.parse(localStorageSort));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(`sort-${id}`, JSON.stringify(sort));
  }, [sort]);

  return (
    <Card className={classnames(className)}>
      <CardHeader color="primary" inverse>{title}</CardHeader>

      <CardBody>
        {status === 'success' ? (
          <Table
            defaultSorted={sort}
            onSortedChange={setSort}
            columns={data.attributes.queueListViewColumnMap.map(h => ({
              accessor: camelCase(h.columnName),
              Header: h.displayHeader,
              show: !h.isHidden,
              Cell: d => <Cell data={d} header={h} />,
            }))}
            data={data.attributes.data}
            getTrProps={(state, rowInfo) => ({
              style: {
                cursor: 'pointer',
              },
              onClick: (e, handleOriginal) => (
                handleOriginal
                  ? handleOriginal()
                  : onItemClick(rowInfo.original)
              ),
            })}
          />
        ) : (
          <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
        )}
      </CardBody>
    </Card>
  );
};

QueueCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  onItemClick: PropTypes.func,
};

QueueCard.defaultProps = {
  className: undefined,
  onItemClick: () => {},
};

export default QueueCard;
